import React, { useState } from "react";
import { useMutation } from "@apollo/client";

import { Alert } from "../../components/Alert";
import { Input } from "../../components/Input";
import { Button, NakedButton } from "../../components/Button";
import { ColContainer } from "../../components/Container";
import {
	GraphqlErrorMessage,
	ValidationErrorMessage,
} from "../../components/ErrorMessage";

import { updatePasswordQuery } from "./queries";
import authManager from "../../lib/authManager";

const PasswordForm = ({ User }) => {
	const [updatePassword, { loading, error: submitError }] = useMutation(updatePasswordQuery);

	const [form, setForm] = useState({
		password: "",
		passwordConfirm: "",
	});

	const [initialForm, setInitialForm] = useState({
		password: "",
		passwordConfirm: "",
	});

	const [errors, setErrors] = useState({});
	const [showSuccess, setShowSuccess] = useState(false);

	const isPristine =
		form.password === initialForm.password &&
		form.passwordConfirm === initialForm.passwordConfirm;

	const handleChange = (field) => (value) => {
		setShowSuccess(false);

		setForm((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const validate = () => {
		const errs = {};

		if (!form.password) {
			errs.password = "Please enter a password";
		}

		if (form.password !== form.passwordConfirm) {
			errs.passwordConfirm = "Your passwords do not match";
		}

		return errs;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const validationErrors = validate();
		setErrors(validationErrors);

		if (Object.keys(validationErrors).length > 0) return;

		try {
			await updatePassword({
				variables: {
					password: form.password,
					userId: authManager.userId,
				},
			});

			// reset form after success
			const emptyForm = { password: "", passwordConfirm: "" };
			setForm(emptyForm);
			setInitialForm(emptyForm);
			setShowSuccess(true);
		} catch (err) {
			// handled by submitError
		}
	};

	const handleReset = () => {
		setForm(initialForm);
		setErrors({});
		setShowSuccess(false);
	};

	return (
		<form onSubmit={handleSubmit}>
			{showSuccess && (
				<Alert flavour="success">
					Your changes have been saved.
				</Alert>
			)}

			{submitError && <GraphqlErrorMessage error={submitError} />}
			{Object.keys(errors).length > 0 && <ValidationErrorMessage />}

			<ColContainer>
				{/* helps password managers */}
				<input name="email" defaultValue={User.email} hidden readOnly />

				<Input
					label="Password"
					type="password"
					autoComplete="new-password"
					value={form.password}
					onValueChange={handleChange("password")}
					error={errors.password}
				/>

				<Input
					label="Confirm password"
					type="password"
					autoComplete="new-password"
					value={form.passwordConfirm}
					onValueChange={handleChange("passwordConfirm")}
					error={errors.passwordConfirm}
				/>
			</ColContainer>

			<Button type="submit" disabled={loading || isPristine}>
				Update password
			</Button>

			{!isPristine && (
				<NakedButton
					type="button"
					flavour="gray"
					disabled={loading}
					onClick={handleReset}
				>
					Cancel
				</NakedButton>
			)}
		</form>
	);
};

export default PasswordForm;